import AppGlobals from '../../AppGlobals';
import AudioPlayer from '../Middleware/AudioPlayer';
import _ from 'lodash';

export default function setUpAudio() {
	return (dispatch, getState) => {
		const {
			audioIsLooping,
			audioIsAutoAdvance,
			audioRate,
		} = getState().App;

		AppGlobals.audioPlayer = new AudioPlayer({
			debugMode: AppGlobals.debugMode,
			isLooping: audioIsLooping,
			isAutoAdvance: audioIsAutoAdvance,
			rate: audioRate,
			pulseInterval: AppGlobals.pulseInterval,
			baseURL: AppGlobals.mediaBaseURL,
			reduxDispatch: dispatch,
			reduxGetState: getState,
		});
		AppGlobals.audioPlayer.initialize();
	};
}



